/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

// Pines fijos (4-9, A0) sin relación con los zona_1..5 de luces_ciudad (8-12)
// pese al solape 8/9: quirk del legacy preservado.
export const ciudad_reestablecer = (block, generator) => {
  generator.definitions_.ciudad_reestablecer = `
#define UMBRALDELUZ 500

void reestablecerServicio() {
  digitalWrite(5, LOW);
  digitalWrite(6, LOW);
  digitalWrite(7, LOW);
  digitalWrite(4, LOW);
}
`;

  generator.setups_.ciudad_reestablecer = `
pinMode(5, OUTPUT);
pinMode(6, OUTPUT);
pinMode(7, OUTPUT);
pinMode(4, OUTPUT);
pinMode(9, OUTPUT);
pinMode(8, OUTPUT);

digitalWrite(5, HIGH);
digitalWrite(6, HIGH);
digitalWrite(7, HIGH);
digitalWrite(4, HIGH);
digitalWrite(8, HIGH);
digitalWrite(9, HIGH);

reestablecerServicio();
`;

  return `
if (analogRead(A0) < UMBRALDELUZ) {
  digitalWrite(8, LOW);
  digitalWrite(9, LOW);
} else {
  digitalWrite(8, HIGH);
  digitalWrite(9, HIGH);
}
`;
};

export const luces_ciudad = (block, generator) => {
  const estado = block.getFieldValue('STAT');
  const zona = block.getFieldValue('ZONA');

  generator.definitions_.luces_ciudad = `
#define zona_1 12
#define zona_2 11
#define zona_3 10
#define zona_4 9
#define zona_5 8
`;

  generator.setups_.luces_ciudad = `
pinMode(zona_1, OUTPUT);
pinMode(zona_2, OUTPUT);
pinMode(zona_3, OUTPUT);
pinMode(zona_4, OUTPUT);
pinMode(zona_5, OUTPUT);

digitalWrite(zona_1, HIGH);
digitalWrite(zona_2, HIGH);
digitalWrite(zona_3, HIGH);
digitalWrite(zona_4, HIGH);
digitalWrite(zona_5, HIGH);
`;

  return `\ndigitalWrite(zona_${zona}, ${estado});\n`;
};

const installColon = (generator) => {
  generator.definitions_.luces_colon = `
#include <Adafruit_NeoPixel.h>
#define PINOCOLON 3
#define NUMPIXELSCOLON 16

Adafruit_NeoPixel pixelsColon(NUMPIXELSCOLON, PINOCOLON, NEO_GRB + NEO_KHZ800);
`;
  generator.setups_.luces_colon = 'pixelsColon.begin();';
};

const colonCode = (led, colorArgs) => {
  const ledsuma = parseInt(led, 10) + 1;
  const ledsuma2 = parseInt(led, 10) + 2;
  const ledsuma3 = parseInt(led, 10) + 3;
  return `
pixelsColon.setPixelColor(${led},pixelsColon.Color(${colorArgs}));
pixelsColon.setPixelColor(${ledsuma},pixelsColon.Color(${colorArgs}));
pixelsColon.setPixelColor(${ledsuma2},pixelsColon.Color(${colorArgs}));
pixelsColon.setPixelColor(${ledsuma3},pixelsColon.Color(${colorArgs}));
pixelsColon.show();
delayMicroseconds(300);
`;
};

export const luces_colon = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  const led = block.getFieldValue('LED') || '0';
  installColon(generator);
  return colonCode(led, color);
};

export const luces_colon_off = (block, generator) => {
  const led = block.getFieldValue('LED') || '0';
  installColon(generator);
  return colonCode(led, '0, 0, 0');
};

const installObelisco = (generator) => {
  generator.definitions_.luces_obelisco = `
#include <Adafruit_NeoPixel.h>
#define PINOBELISCO 2
#define NUMPIXELSOBELISCO 4

Adafruit_NeoPixel pixelsObelisco(NUMPIXELSOBELISCO, PINOBELISCO, NEO_GRB + NEO_KHZ800);
`;
  generator.setups_.luces_obelisco = 'pixelsObelisco.begin();';
};

const obeliscoCode = (led, colorArgs) => `
pixelsObelisco.setPixelColor(${led},pixelsObelisco.Color(${colorArgs}));
pixelsObelisco.show();
delayMicroseconds(300);
`;

export const luces_obelisco = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  const led = block.getFieldValue('LED') || '0';
  installObelisco(generator);
  return obeliscoCode(led, color);
};

export const luces_obelisco_off = (block, generator) => {
  const led = block.getFieldValue('LED') || '0';
  installObelisco(generator);
  return obeliscoCode(led, '0, 0, 0');
};
